// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as FareEstimateResultCmsApiModel$PorterinFeature from "../api-model/FareEstimateResultCmsApiModel.mjs";

function apiModelToState(model) {
  return {
          meta: {
            title: model.data.attributes.meta.title,
            description: model.data.attributes.meta.description
          },
          vehicles: $$Array.map((function (vehicle) {
                  return {
                          name: vehicle.attributes.vehicle_name,
                          image: {
                            path: vehicle.attributes.vehicle_image.image.url,
                            alt_text: vehicle.attributes.vehicle_image.alt_text
                          }
                        };
                }), model.data.attributes.vehicles_info.data),
          callback: $$Array.map((function (item) {
                  return {
                          geo_region_id: item.geo_region_id,
                          show_callback: item.show_callback,
                          city_callback: {
                            text: item.callback_text.text,
                            sub_text: item.callback_text.sub_text
                          }
                        };
                }), model.data.attributes.callback),
          promo_banners: $$Array.map((function (promo_banner) {
                  return {
                          geo_region_id: promo_banner.geo_region_id,
                          banner: $$Array.map((function (banner_data) {
                                  return {
                                          image: {
                                            path: banner_data.image.data.attributes.url,
                                            alt_text: banner_data.image_alt
                                          },
                                          text: banner_data.text,
                                          sub_text: banner_data.sub_text,
                                          service_name: banner_data.service_name,
                                          link: banner_data.link
                                        };
                                }), promo_banner.banner)
                        };
                }), model.data.attributes.promo_banners)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(FareEstimateResultCmsApiModel$PorterinFeature.t_decode(json), "FareEstimateResultCmsEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
